import React from 'react';
import OregonMap from './OregonMap';
import './App.css';

function App() {
  return (
    <div>
      <h1>Explore Oregon</h1>
      <OregonMap />
    </div>
  );
}

export default App;
